mobileSize = 1050;

function placeTicketBtn() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.ticket').appendTo('.header-bottom');
  } else {
    $('.ticket').insertBefore('.mobile-nav-toggle');
  }
}

function placeCountdown() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('#siteInfoBannerWidget').appendTo('.tier-one');
  } else {
    $('#siteInfoBannerWidget').insertAfter('.header-logo');
  }
}

$(document).ready(function () {
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1050) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1051) {
    $('body').removeClass('saffireMobileSize');
  }

  setTimeout(() => {
    let infoBannerContent = $('.countdownDays').text().split(" ")[0]
    if (infoBannerContent != "Thanks") {
      $(".countdownDays").children('').text('days until ')
      $(".countdownDays").prepend('Only ')
    }
  }, 1500)

  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
  $('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Place Ticket Button
  placeTicketBtn();

  // Place Countdown
  placeCountdown();

  // Custom Email Signup
  $('.homepage .emailSignup .emailSignupText').text('Sign up for the latest from Berlin Fair!');
  $('.homepage .emailSignup .emailSubmitButton')
    .appendTo('.homepage .emailSignup .emailInputField')
    .addClass('button')
    .text('Subscribe');
});

$(window).load(function () {
  $('body').addClass('pageIsLoaded');
});

$(window).resize(function () {
  // Place Ticket Button
  placeTicketBtn();

  // Place Countdown
  placeCountdown();
});